module.exports = "/fonts/illustrasi-line-dash-coffee-0c2d92c833e2e8e18d43f1ed028ca607.svg";